import React from 'react'
import PropTypes from 'prop-types'

import FilterOptimiser from '../../../../../components/FilterGrid'

export default function Filter({ setFilters, filters }) {
  return (
    <div
      style={{
        padding: '12px 0px',
        marginBottom: '2px',
        boxShadow:
          'inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 1px 2px 0 rgb(60 64 67 / 30%), 0 0px rgb(60 64 67 / 15%)',
        backgroundColor: 'rgba(248, 248, 248, 0.81)',
      }}
    >
      <FilterOptimiser
        prestationFilter={true}
        statusDriversFilter={true}
        dateLivraisonFilter={false}
        setFilters={setFilters}
        filtersValues={filters}
      />
    </div>
  )
}
Filter.propTypes = {
  setFilters: PropTypes.func,
  filters: PropTypes.object,
}
